import {
  APP_ZONES,
  CanvasZone,
  NewWorkflowWidgetConfig,
  PermissionConfig,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
} from '@finxone-platform/shared/sys-config-types';

export const getV1_0_166ToV1_0_167 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: () => {
        return 'v1.0.167';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: (permissionSection: PermissionConfig): PermissionConfig => {
        const { roles, subscriptions } = permissionSection;
        roles.forEach((role) => {
          processZone(role.zones[APP_ZONES.CARD_MANAGEMENT_ZONE], modifyCardManagementPageWidgetConfig);
          processZone(role.zones[APP_ZONES.PROFILE], modifyProfilePageWidgetConfig);
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
        };
      },
    },
  };
};

// Utility to extract and modify pages for a given zone
function processZone(zone: CanvasZone | null, widgetModifier: (pages: WorkflowPageConfig[]) => void) {
  if (!zone) return;

  const mobilePages = zone?.canvases?.subscription?.['default']?.mobile?.pages as
    | WorkflowPageConfig[]
    | undefined;
  const desktopPages = zone?.canvases?.subscription?.['default']?.desktop?.pages as
    | WorkflowPageConfig[]
    | undefined;
  const tabletPages = zone?.canvases?.subscription?.['default']?.tablet?.pages as
    | WorkflowPageConfig[]
    | undefined;

  if (mobilePages?.length) {
    widgetModifier(mobilePages);
  }

  if (desktopPages?.length) {
    widgetModifier(desktopPages);
  }

  if (tabletPages?.length) {
    widgetModifier(tabletPages);
  }
}

function modifyCardManagementPageWidgetConfig(pages: WorkflowPageConfig[]) {
  pages.find((page) => {
    if (page && (page.name === 'card-transactions' || page.pageConfiguration.url === 'card-transactions')) {
      page.widgets = page.widgets.map((widget) => {
        if (
          widget.name === WidgetNames.TEXT_WIDGET &&
          [
            'Text Widget: Icon & Amount',
            'Text Widget: Profile Details',
            'Text Widget: Transaction Details',
          ].includes(widget.widgetConfiguration.widgetConfigDisplayName)
        ) {
          updateWidgetPropertyConfig(widget);
        }
        return widget;
      });
    }
  });

  return pages;
}

function modifyProfilePageWidgetConfig(pages: WorkflowPageConfig[]) {
  pages.find((page) => {
    if (
      page &&
      (page.name === 'notification-beneficiary-added' ||
        page.name === 'notification-beneficiary-edited' ||
        page.name === 'notification-beneficiary-removed')
    ) {
      page.widgets = page.widgets.map((widget) => {
        if (
          widget.name === WidgetNames.TEXT_WIDGET &&
          widget.widgetConfiguration.widgetConfigDisplayName === 'Beneficiary Info'
        ) {
          updateWidgetPropertyConfig(widget);
        }
        return widget;
      });
    }
  });
  return pages;
}

function updateWidgetPropertyConfig(widget: NewWorkflowWidgetConfig) {
  widget.widgetConfiguration.attributes = {
    ...widget.widgetConfiguration.attributes,
    widgetProperties: {
      ...widget.widgetConfiguration.attributes?.widgetProperties,
      showSkeletonPreviewOption: true, // add this flag to display the skeleton preview option into RHS for these required text widgets
    },
  };
  return widget;
}
